module.exports = __webpack_public_path__ + "img/shouchi.96a222e9.gif";